module.exports = __webpack_public_path__ + "static/media/chat.ab316797.svg";